import React, { useState } from "react";
import "./ReviewScreen.css";

const ReviewScreen = ({ wrongQuestions, subject, classLevel, onBack }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  if (!wrongQuestions || wrongQuestions.length === 0) {
    return (
      <div className="review-container">
        <div className="no-mistakes">
          <h2>🎉 No Mistakes to Review!</h2>
          <p>You answered all questions correctly. Great job!</p>
          <button className="back-btn" onClick={onBack}>
            Back to Results
          </button>
        </div>
      </div>
    );
  }

  const currentQuestion = wrongQuestions[currentQuestionIndex];
  const progress = ((currentQuestionIndex + 1) / wrongQuestions.length) * 100;

  const handleNext = () => {
    if (currentQuestionIndex < wrongQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  return (
    <div className="review-container">
      <div className="review-header">
        <h2>Review Mistakes</h2>
        <div className="review-subtitle">
          {classLevel} - {subject}
        </div>
      </div>

      <div className="review-progress">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
        <div className="progress-text">
          Question {currentQuestionIndex + 1} of {wrongQuestions.length}
        </div>
      </div>

      <div className="question-card">
        <h3 className="question-text">{currentQuestion.question}</h3>
        
        <div className="options-review">
          {currentQuestion.options.map((option, index) => {
            const isCorrect = index === currentQuestion.correctAnswer;
            const isSelected = index === currentQuestion.selected;
            
            return (
              <div
                key={index}
                className={`option-review ${isCorrect ? 'correct' : ''} ${
                  isSelected && !isCorrect ? 'incorrect' : ''
                }`}
              >
                <div className="option-header">
                  <span className="option-letter">{String.fromCharCode(65 + index)}.</span>
                  <span className="option-status">
                    {isCorrect && "✓ Correct Answer"}
                    {isSelected && !isCorrect && "✗ Your Answer"}
                  </span>
                </div>
                <div className="option-text">{option}</div>
              </div>
            );
          })}
        </div>

        <div className="explanation-section">
          <h4>Explanation:</h4>
          <p>{currentQuestion.explanation || "No explanation provided."}</p>
        </div>

        {currentQuestion.topics && (
          <div className="topics-section">
            <h4>Topics:</h4>
            <div className="topics-list">
              {currentQuestion.topics.map((topic, index) => (
                <span key={index} className="topic-tag">
                  {topic}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="review-navigation">
        <button
          onClick={handlePrevious}
          disabled={currentQuestionIndex === 0}
          className="nav-btn prev-btn"
        >
          ← Previous
        </button>
        
        <button onClick={onBack} className="nav-btn back-btn">
          Back to Results
        </button>
        
        <button
          onClick={handleNext}
          disabled={currentQuestionIndex === wrongQuestions.length - 1}
          className="nav-btn next-btn"
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default ReviewScreen;